import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CollapseWithArrow.css';
import IconContainer from '../iconContainer/IconContainer';
import { Collapse } from 'reactstrap';

class CollapseWithArrow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    render() {
        return (
            <div className={"collapse-with-arrow-container " + (this.props.className || "")}>
                <div className="collapse-with-arrow-title-container" onClick={this.toggle}>
                    <h6 className="collapse-with-arrow-title">{this.props.title}</h6>
                    {this.renderCollapseArrow()}
                </div>
                <Collapse isOpen={this.state.isOpen}>
                    {this.props.children}
                </Collapse>
            </div>
        );
    }

    renderCollapseArrow = () => {
        let iconName = "keyboard_arrow_" + (this.state.isOpen ? "down" : "right");
        return (
            <IconContainer onClick={this.toggle} className="collapse-with-arrow-icon" icon={iconName} />
        )
    };

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
}

CollapseWithArrow.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired
};

export default CollapseWithArrow;



// WEBPACK FOOTER //
// ./src/components/commonComponents/collapseWithArrow/CollapseWithArrow.js